import "./PageFormWidget.scss";
import React from "react";

type PageFormWidgetProps = {
  children: React.ReactNode;
  isSummary?: boolean;
  bodyClassName?: string;
};

const PageFormWidget: React.FC<PageFormWidgetProps> = ({
  children,
  isSummary = false,
  bodyClassName = "",
}) => {
  if (isSummary) {
    return <>{children}</>;
  }

  return (
    <div
      className={`page-form-widget-container`}
      data-testid={"page-form-widget"}
    >
      <div className={`page-form-widget-body ${bodyClassName}`}>{children}</div>
    </div>
  );
};

export default PageFormWidget;
